module.exports = __webpack_public_path__ + "static/media/L2.90c20a19.jpg";